export interface TsAppVersion {
    version: string;
    name: string;
    description?: string;
    versionLong?: string;
    versionDate: string;
    gitCommitHash?: string;
    gitCommitDate?: string;
    gitTag?: string;
};
export const versions: TsAppVersion = {
    version: '2.5.4',
    name: 'fpar',
    versionDate: '2025-12-12T20:51:14.182Z',
};
export default versions;
